import { Splide } from '@splidejs/splide';

export default function() {
	let productSlider = document.getElementById('product-slider');
	let thumbnailSlider = document.getElementById('thumbnail-slider');
	if (!productSlider || !thumbnailSlider) {
		return;
	}
	var main = new Splide( '#product-slider', {
		type       : 'fade',
		heightRatio: 1,
		pagination : false,
		arrows     : false,
		perPage: 1,
	} );
	
	var thumbnails = new Splide( '#thumbnail-slider', {
		trimSpace			 : true,
		rewind          : true,
		fixedWidth      : 82,
		fixedHeight     : 82,
		isNavigation    : true,
		gap             : 10,
		pagination      : false,
		center: true,
		perPage: 4.5,
		arrows: false,
		dragMinThreshold: {
			mouse: 4,
			touch: 10,
		},
		breakpoints : {
			640: {
				fixedWidth  : 78,
				fixedHeight : 78,
			},
		},
	} );
	
	main.sync( thumbnails );
	main.mount();
	thumbnails.mount();
}